import { render, staticRenderFns } from "./Drill.vue?vue&type=template&id=1b8525f6&scoped=true&lang=pug&"
import script from "./Drill.vue?vue&type=script&lang=ts&"
export * from "./Drill.vue?vue&type=script&lang=ts&"
import style0 from "./Drill.vue?vue&type=style&index=0&id=1b8525f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8525f6",
  null
  
)

export default component.exports